import { render, staticRenderFns } from "./NewRelease.vue?vue&type=template&id=e1a7723c&scoped=true&"
import script from "./NewRelease.vue?vue&type=script&lang=js&"
export * from "./NewRelease.vue?vue&type=script&lang=js&"
import style0 from "./NewRelease.vue?vue&type=style&index=0&id=e1a7723c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1a7723c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VRow})
